import client, { PRIVATE_CLIENT } from '../../services/client';
export const getCallLogs = async (number_id, page = 1) => {
    return await client.get(`number/${number_id}/call-log/`, PRIVATE_CLIENT, null, {
        page_index: page
    });
};
export const getCallLog = async (business_id, number_id, call_id) => {
    return await client.get(`business/${business_id}/number/${number_id}/call_log/${call_id}/`, PRIVATE_CLIENT, null);
};
